<ng-container *ngIf="!accountLoading && (account$ | async) as account; else contentLoading">

  <div class="flex align-items-center mb-3">
    <span class="p-input-icon-left flex-grow-1 mr-3">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        (input)="faqsTable.filterGlobal($any($event).target.value, 'contains')"
        placeholder="Search FAQs"
      />
    </span>
    <p-dropdown
      class="mr-3 flex-shrink-0"
      data-testid="faq-category-filter"
      [options]="categoryFilterOptions"
      [(ngModel)]="selectedCategory"
      (onChange)="onCategoryFilter(faqsTable, $event.value)"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      [style]="{ 'min-width': '12rem' }"
    ></p-dropdown>
    <button
      pButton
      pRipple
      type="button"
      label="Categories"
      icon="pi pi-tags"
      class="p-button-text flex-shrink-0"
      (click)="onEditCategories()"
    ></button>
    <button
      pButton
      pRipple
      type="button"
      label="Add FAQ"
      icon="pi pi-plus"
      class="p-button-rounded flex-shrink-0"
      (click)="onAddFaq($event)"
    ></button>
  </div>

  <p-table
    #faqsTable
    [value]="faqsAsList(account.data?.content?.faqs)"
    [globalFilterFields]="['question', 'answer']"
    styleClass="mt-3 p-datatable-striped"
    dataKey="_meta.id"
    responsiveLayout="scroll"
  >

    <ng-template pTemplate="header">
      <tr>
        <th>Question</th>
        <th style="width: 22%">Category</th>
        <th style="width: 9rem">On FAQ page</th>
        <th style="width: 9rem"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-faq>
      <tr [class.is-deleted]="faq._meta.deleted">
        <td>
          <strong>{{ faq.question || '(no question)' }}</strong>
          <div class="text-sm muted answer-preview">{{ faq.answer }}</div>
        </td>
        <td>{{ categoryLabel(faq) }}</td>
        <td>
          <i class="pi" [ngClass]="onFaqPage(faq) ? 'pi-check text-green-600' : 'pi-minus text-400'"
            [title]="onFaqPage(faq) ? 'Shown in full-page FAQ blocks' : 'Only where a block picks it'"></i>
        </td>
        <td class="row-actions">
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            class="p-button-rounded p-button-text"
            (click)="onEditFaq($event, faq)"
          ></button>
          <button
            *ngIf="!faq._meta.deleted"
            pButton
            pRipple
            type="button"
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-button-text"
            (click)="onDeleteFaq($event, faq)"
          ></button>
          <button
            *ngIf="faq._meta.deleted"
            pButton
            pRipple
            type="button"
            icon="pi pi-refresh"
            class="p-button-rounded p-button-success p-button-text"
            (click)="onRestoreFaq($event, faq)"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="empty-row">
          <ng-container *ngIf="selectedCategory; else noFaqs">No FAQs in this category.</ng-container>
          <ng-template #noFaqs>
            No FAQs yet. Add one and tick the pages it should appear on — it
            reaches picaluna.com on the next site publish.
          </ng-template>
        </td>
      </tr>
    </ng-template>

  </p-table>

</ng-container>

<!-- Shown while the account loads. Without it the modal opens onto an empty
     body for a second or two, which reads as broken rather than busy. -->
<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
